export const PAYMENT_FLOW = 'paymentflow'; // used to identify sign up -> subscribe flow
export const COUPON_FLOW = 'couponflow'; // used to identify coupon -> subscribe
